import React from "react";
import { Container, Divider, Paper, Typography } from '@material-ui/core'
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineOppositeContent, TimelineDot } from '@material-ui/lab';

import { Parallax } from "react-parallax";
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
    },
    paper: {
        padding: '6px 16px',
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
    timeAlign: {
        textAlign: 'left'
    }
}))
// import Hello from "./Hello";


export const Skills = () => {
    const classes = useStyles()
    return (

        <div >
            {/* <Hello name="Parallax" /> */}
            <Parallax bgImage={'https://source.unsplash.com/random'} strength={2500}>
                <Container className={classes.root} maxWidth="md" disableGutters>
                <Parallax speed={3}>
                    <Timeline align="alternate" color="primary.contrastText">
                        {codes.map((code, index) => (
                            <TimelineItem key={index}>
                                <TimelineOppositeContent>
                                    <Typography variant="body2" color="textSecondary">
                                        {new Date().toDateString()}
                                    </Typography>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color="secondary" />

                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <Paper elevation={3} className={`${classes.paper} ${classes.timeAlign}`}>
                                        <Typography variant="h6" component="h1">
                                            {code.name}
                                            <Divider variant='inset' color="primary" />
                                        </Typography>
                                        <Typography variant="subtitle1"></Typography>
                                        <blockquote><em>{code.attribue}</em> </blockquote>
                                    </Paper>
                                </TimelineContent>
                            </TimelineItem>
                        ))}


                    </Timeline>
                            </Parallax>
                </Container>
            </Parallax>
            {/* <Parallax
            bgImage={'https://source.unsplash.com/random'}
            strength={400}
            renderLayer={percentage => (
                <div
                    style={{
                        position: 'static',
                        background: `rgba(255, 125, 0, ${percentage * 1})`,
                        left: '0',
                        top: '0',
                        width: percentage * 100,
                        height: percentage * 10,
                    }}
                />
            )}
        >
            <p>... Content</p>
        </Parallax>
        
        <Parallax bgImage={image1} strength={500}>
            <div style={{ height: 500 }}>
                <div style={insideStyles}>HTML inside the parallax</div>
            </div>
        </Parallax>
        <h1>| | |</h1>
        <Parallax bgImage={image3} blur={{ min: -6, max: 0 }}>
            <div style={{ height: 500 }}>
                <div style={insideStyles}>Dynamic Blur</div>
            </div>
        </Parallax>
        <h1>| | |</h1>
        <Parallax bgImage={image2} strength={-1000}>
            <div style={{ height: 500 }}>
                <div style={insideStyles}>Reverse direction</div>
            </div>
        </Parallax>
        <h1>| | |</h1>
        <Parallax
            bgImage={image4}
            strength={200}
            renderLayer={percentage => (
                <div>
                    <div
                        style={{
                            position: "absolute",
                            background: `rgba(255, 125, 0, ${percentage * 1})`,
                            left: "50%",
                            top: "50%",
                            borderRadius: "50%",
                            transform: "translate(-50%,-50%)",
                            width: percentage * 500,
                            height: percentage * 500
                        }}
                    />
                </div>
            )}
        >
            <div style={{ height: 500 }}>
                <div style={insideStyles}>renderProp</div>
            </div>
        </Parallax>
        <Parallax bgImage={image1} strength={500}>
            <div style={{ height: 500 }}>
                <div style={insideStyles}>HTML inside the parallax</div>
            </div>
        </Parallax>
        <h1>| | |</h1>
        <div style={{ height: 500 }} />
        <h2>{"\u2728"}</h2>

        <Parallax blur={{min:5, max:-15}}  bgImage={image1} bgImageAlt="the cat"
            strength={-200}
        >
            Put some text content here - even an empty div with fixed dimensions to have a height
            for the parallax.
            <div style={{ height: '200px' }} />

        </Parallax>
        
        <Parallax strength={300} style={{height:'500px'}}>
            <div>Use the background component for custom elements</div>
            <Background className="custom-bg" >
                <img src={image3} alt="fill murray" />
            </Background>
        </Parallax> */}

        </div>
    );


}
const codes = [
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'HTML',
        attribue: 'Heading, Paragraphs, Images, Input, List, Form, Table, Links'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'CSS',
        attribue: 'Selector, MediaQueries, Responsive, Inline, External, Margin, Padding, FlexBox'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'Bootstrap',
        attribue: 'Responsive, Mobile Devices, Well Design, Form, lists, Table, Grid System, Colors, Fonts, Image Sizing,Navigation'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'Materialize',
        attribue: 'Responsive, Mobile Devices, Well Design, Form, lists, Table, Grid System, Colors, Fonts, Image Sizing,Navigation'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'React',
        attribue: 'Components, Hooks, Context, Router-Dom, UseEffect, UseCallback'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'Material UI',
        attribue: 'Responsive, Mobile Devices, Well Design, Form, lists, Table, Grid System, Colors, Fonts, Image Sizing,Navigation'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'Redux',
        attribue: 'Store, Thunk, Action, Dispatch, UseSelector,'
    },
    {
        id: Math.floor(Math.random() * 10 + 1),
        name: 'Firebase',
        attribue: 'Authentication, Firebase, Firestore, Function, Storage'
    },
]